import React, {
  useState,
  useRef,
  useEffect,
} from "react";
import {
  Box,
  Container,
  Stack,
  Typography,
} from "@mui/material";


import { InputYear } from "../../Components/Inputs/Input_Year.jsx";
import { set } from "lodash";

import {
  getOptions,
  putOptions,
  AccountUrl_get,
  AccountUrl_put,
  ftchPlus,
  CleanAvail,
} from "../../App/Account_urls.jsx";
import ValueInflatable from "../../App/ValueInflatable.jsx";
import { AddDialog } from "../../Components/AddDialog.jsx";
import {
  CollapseAdd,
  CollapseAddLabel,
  CollapseDelete,
  CollapseDeleteLabel,
  CollapseStateLabel,
} from "../../App/CollapseButtons.jsx";
import { Input_label, InputName } from "../../Components/Inputs/Input_Name.jsx";
import { errorClear, errorJsonHasErrors, errorSetPlus } from "../../Components/Inputs/Input_Fns.jsx";
import { InputCheck } from "../../Components/Inputs/Input_Check.jsx";
import { InputSelect1, InputSelect1ES } from "../../Components/Inputs/Select.jsx";
import { InputPercentage } from "../../Components/Inputs/Input_Percentage.jsx";
import { Arrayify } from "../../Functions/utils.jsx";
import { InputButtonGroup } from "../../Components/Inputs/Input_RadioButtonGroup.jsx";

var init_v = {
  Id: 0,
  Actual: false,
  Additional: false,
  Name: "",
  UpToAge: 0,
  FinishMonth: "",
  Repeat: 0,
  SpousePercentage: 0,
  ReduceEoL: 100,
  ReduceSpouseEoL: 100,
  Value: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
  },
};

var efrom = {
  Id: 0,
  Account: "",
  SpousePercentage: 0,
  Value: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
  },
};


var ann = {
  Id: 0,
  Year: new Date().getFullYear() - 1,
  Comment: "",
  BirthYear: 1970,
  Init: [init_v],
  From: [],
  Employment: {
    SelfEmployed: false,
    EIOptOut: false,
    CPPOptOut: false
  },
};




var match = {
  Id: 0,
  Bonus: false,
  PercentOfAccount: 0,
  PercentMatch: 100,
  Account: "",
  Value: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
  },
}

const Match = ({ form, avail, onError, onChange, birthYear }) => {
  const myChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    //setForm(nf);
    console.log(nf);
    onChange(nf);
  };
  const myChange_t = (e) => {
    myChange_any(e.target.name, e.target.value);
  };
  const onChangeMe = (value, uptoage, SpousePercentage, name, repeat) => {
    let nf = {
      ...form,
      Value: value,
    };
    //setForm(nf);
    onChange(nf);
  };

  return (
    <Stack direction="row" spacing={2}>
      {form.Bonus && (
        <InputSelect1ES
          label="Account"
          value={form.Account}
          onChange={myChange_t}
          name="Account"
          avail={avail.BonusAccount}
          tooltip={"The bonus value will be added directly to this account. If its taxable it will still go through Gross* but will then automatically be transferred to this account "}
        />
      )}
      {!form.Bonus && (
        <InputSelect1
          label="Account"
          value={form.Account}
          onChange={myChange_t}
          name="Account"
          avail={avail.MatchAccount}
          tooltip={"The employee value and matching value will be added directly to this account. If its taxable it will still go through Gross* but will then automatically be transferred to this account "}
        />
      )}
      {!form.Bonus && (
        <InputPercentage
          label="Match %"
          name="PercentMatch"
          percent={form.PercentMatch}
          maxPct={1000}
          onChange={myChange_t}
          onError={onError}
          tooltip="The percentage the company will match."
        />
      )}
      <InputPercentage
        label="Salary %"
        name="PercentOfAccount"
        percent={form.PercentOfAccount}
        onChange={myChange_t}
        onError={onError}
        tooltip={"Salary Percentage we will use as a basis for the " + (form.Bonus ? "bonus" : "company match")}
      />
      <ValueInflatable
        key={"match:" + form.Id}
        label={form.Bonus ? "Bonus" : "Flat"}
        form={form.Value}
        onChange={onChangeMe}
        avail={avail}
        onError={onError}
        showInf={false}
        tooltip={"The " + (form.Bonus ? "bonus value" : "to match against") + " (when not using Salary %)"}
        birthYear={birthYear}
      />
    </Stack>


  )
}

const Employment = ({ form, avail, onChange }) => {
  const myChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    console.log(nf);
    onChange(nf);
  };
  console.log(form)

  return (

    <Stack >
      <InputCheck
        label="Self Employed"
        name="SelfEmployed"
        value={form.SelfEmployed}
        sx={{ mt: -5 }}
        tooltip="Are you Self Employed, this will control if you have to pay the employer portion of CPP, do not select if you're employer (or CCPC) pays the employer part of CPP."
        onChange={myChange_any}
      />
      <InputCheck
        label="EI Opt Out"
        name="EIOptOut"
        value={form.EIOptOut}
        sx={{ mt: -5 }}
        // disabled{form.SelfEmployed === false}
        tooltip={"You can elect to continue paying EI when self employed as a professional or if you own your own CCPC"}
        onChange={myChange_any}
      />
      <InputCheck
        label="CPP Opt Out"
        name="CPPOptOut"
        value={form.CPPOptOut}
        sx={{ mt: -5 }}
        tooltip={"You can opt out if you are already drawing CPP"}
        onChange={myChange_any}
      />
    </Stack>
  )
}




const ReduceEoL = ({ form, onChange_any, errors, onError }) => {

  const myChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  return (
    <Stack direction="row" spacing={2}>
      <InputPercentage
        label="EoL %"
        name="ReduceEoL"
        percent={form.ReduceEoL}
        onChange={myChange_t}
        width={80}
        tooltip={"How much to reduce this expense when this person hits End Of Life, which would then be transferred to the Spouse, 100% means no reduction"}
        errors={errors}
        onError={(e) => { onError("ReduceEoL", e) }}

      />
      <InputPercentage
        label="Sp EoL %"
        name="ReduceSpouseEoL"
        percent={form.ReduceSpouseEoL}
        onChange={myChange_t}
        width={80}
        tooltip={"How much to reduce this expense when the sppuse hits End Of Life, 100% means no reduction"}
        errors={errors}
        onError={(e) => { onError("ReduceSpouseEoL", e) }}
      />
    </Stack>
  )
}

const ExpenseType = ({ value, onChange, label, name, avail, errors, onError, tooltip, width, disabled }) => {

  const myChange_t = (e) => {
    onChange(e);
  };

  return (
    <Stack direction="row" spacing={2}>
      <InputSelect1ES
        label={label}
        value={value}
        onChange={myChange_t}
        name={name}
        avail={avail}
        tooltip={tooltip}
        minWidth={170}
        //maxWidth={100}
        errors={errors}
        disabled={disabled}

      />
    </Stack>)
}


const SourceAccount = ({ avail, form, onChange, onError }) => {
  const [errors, setErrors] = useState({})

  const myChange_account = (e) => {
    let v = e.target.value
    let ind = avail.ExpenseFromAccount.indexOf(v)
    console.log(v)
    console.log(ind)
    if (ind !== -1) {
      let nf = {
        ...form,
        "Account": v,
      };
      console.log(nf);
      validate(nf)
      onChange(nf);
    }
  };
  const myChangeValue = (value, uptoage, SpousePercentage, name) => {
    let nf = {
      ...form,
      SpousePercentage: SpousePercentage,
      [name]: value,
    };
    validate(nf)
    onChange(nf);
  };

  const getMax = () => {
    return null
  }
  const validate = (f) => {
    let ne = structuredClone(errors)

    // let errv = ""
    let erra = ""

    if (Number(f.Value.Value) !== 0 && f.Account === "") {
      erra = "Set an account"
    }
    if (Number(f.Value.Value) === 0 && f.Account !== "") {
      erra = "Set a value"
    }


    // set(ne, "Value", errv)
    set(ne, "Account", erra)

    console.log(ne)
    setErrors(ne)
    if (onError !== null) {
      onError(errorJsonHasErrors(ne) ? "Errors" : "")
    }
  }

  console.log(errors)
  return (
    <Stack
      spacing={2}
      direction="row"
    >
      <InputSelect1ES
        label="Source Account"
        value={form.Account}
        onChange={myChange_account}
        name="Account"
        avail={avail.ExpenseFromAccount}
        errors={errors}

      />

      <ValueInflatable
        key="form.value"
        label="Source"
        form={form.Value}
        onChange={myChangeValue}
        max={getMax()}
        SpousePercentage={form.SpousePercentage}
        showInf={false}
        avail={avail}
        name="Value"
        dosp={false} // this is unused right now anyway so just remove it, till its dealt with
        onError={onError}
        errors={errors}
      />
    </Stack>
  );
};


const SourceAccounts = ({ avail, form, onChange, onError }) => {
  const [errors, setErrors] = useState({})

  const myChangeSub_i = (i, value) => {
    let json = form
    json[i] = value;
    onChange(json);
  };

  const myDelete_i = (Id) => {
    let json = form.slice();
    json = json.filter((o) => o.Id !== Id);
    onChange(json);
  };

  const myAdd = () => {
    let n = structuredClone(efrom);
    let json = [];
    if (form) {
      json = form.slice();
      n.Id = Math.max(...form.map((o) => o.Id), 0) + 1;
    }
    console.log(n);
    json.push(n);
    console.log(json);
    onChange(json);
  };
  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  return (
    <Stack
      spacing={2}
      direction="row"
      sx={{ pl: 2 }}
    >

      <CollapseAddLabel
        label="Source"
        //mt={2}
        onClick={() => myAdd()}
      />
      <Stack spacing={2}>
        {Arrayify(form).map((v, i) => (
          <Stack key={"st-" + i} direction="row" spacing={2}>
            <SourceAccount
              form={v}
              avail={avail}
              onChange={(e) => myChangeSub_i(i, e)}
              onError={(e) => myError("pullfrom", i, e)}
              errors={errors}
            />
            <CollapseDelete
              onClick={(e) => myDelete_i(v.Id)}
            />
          </Stack>
        ))}
      </Stack>
    </Stack>
  )
}



const ValueInit = ({ name, avail, form, onChange, dosp, doRepeat, negative, onError, doFinishMonth = false,
  birthYear
}) => {
  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    //setForm(nf);
    console.log(nf);
    onChange(nf);
  };

  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  const onChangeMe = (value, uptoage, SpousePercentage, name, repeat) => {
    let nf = {
      ...form,
      UpToAge: uptoage,
      SpousePercentage: SpousePercentage,
      Value: value,
      Repeat: repeat,
    };
    //setForm(nf);
    onChange(nf);
  };
  return (
    <Stack direction="row" spacing={2}>
      <Stack>
        <InputCheck
          label="Actual"
          name="Actual"
          value={form.Actual}
          onChange={onChange_any}
          sx={{ mt: -4 }}
          tooltip={"Indicates this " + name + " is an actual value.  This is currently unused."}
        />
        <InputCheck
          label="Additional"
          name="Additional"
          value={form.Additional}
          onChange={onChange_any}
          sx={{ mt: -2 }}
          tooltip={"This is an irregular " + name + ", kept when doing sweeps"}
        />
        {false && (
          <InputName
            value={form.Name}
            onChange={onChange_any}
            tooltip={"Name of this additional entry"}
          />
        )}
      </Stack>

      <ValueInflatable
        key={"VI-V - " + form.Id}
        form={form.Value}
        doUpTo={true}
        uptoage={form.UpToAge}
        dosp={dosp}
        repeat={form.Repeat}
        doRepeat={doRepeat}
        showInf={false}
        doInfR={true}
        SpousePercentage={form.SpousePercentage}
        onChange={onChangeMe}
        avail={avail}
        negative={negative}
        onError={onError}
        tooltip={"The value of the " + name}
        doFinishMonth={doFinishMonth}
        finishMonth={form.FinishMonth}
        onChange_FinishMonth={onChange_t}
        birthYear={birthYear}
      />
    </Stack>
  );
};

const ValueYear = ({ accountType, name, avail, form, onChange, dosp, doRepeat, doReduceEoL, doTaxTreatment, doFrom, negative, onError, expenseType }) => {
  const [errors, setErrors] = useState({})
  const [addNotes, setAddNotes] = useState(false);

  const validate = (f) => {
  }

  const onChange_any = (n, v) => {
    console.log("VY:change");
    console.log(form);
    console.log(n);
    console.log(v);
    let nf = {
      ...form,
      [n]: v,
    };
    console.log(nf);
    validate(nf)
    onChange(nf);
  };


  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  const onChangeMe = (n, e, i) => {
    // console.log("VY:onchangeMe");
    // console.log(e);
    // console.log(i);
    let json = form[n];
    json[i] = e;
    onChange_any(n, json);
  };

  const myChangeInit = (n, v, i) => {
    // console.log("VY:onchangeMe");
    // console.log(e);
    // console.log(i);
    let json = form.Init;
    json = set(json, [i, n], v);
    console.log(json)
    onChange_any("Init", json);
  };
  // const onChangeMatch = (e, i) => {
  //   // console.log("VY:onchangeMe");
  //   // console.log(e);
  //   // console.log(i);
  //   let json = form;
  //   json.Init[i] = e;
  //   onChange_any("Match", json.Init);
  // };

  const onAdd = () => {
    let n_init = structuredClone(init_v);
    let json = [];
    if (form.Init) {
      json = form.Init.slice();
      n_init.Id = Math.max(...form.Init.map((o) => o.Id), 0) + 1;
    }
    console.log(n_init);
    json.push(n_init);
    onChange_any("Init", json);
  };
  const onDelete = (e, Id) => {
    let json = form.Init.slice();
    json = json.filter((o) => o.Id !== Id);
    onChange_any("Init", json);
  };
  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  const onAddMatch = (bonus) => {
    let n_m = structuredClone(match);
    n_m.Bonus = bonus
    let json = [];
    if (form.Match) {
      json = form.Match.slice();
      n_m.Id = Math.max(...form.Match.map((o) => o.Id), 0) + 1;
    }
    console.log(avail)

    console.log(avail.MatchAccount)
    n_m.Account = avail.MatchAccount.length > 0 ? avail.MatchAccount[0] : "";
    // console.log(n_ret);
    json.push(n_m);
    onChange_any("Match", json);
  };

  const onDeleteMatch_i = (name, Id) => {
    let json = form[name].slice();
    json = json.filter((o) => o.Id !== Id);
    onChange_any(name, json);
  };

  useEffect(() => {
    if (form.Comment && form.Comment !== "") {
      setAddNotes(true)
    }

  }, [form])


  return (
    <Container maxWidth="true">
      <Box sx={{ my: 2, pt: 3, pb: 1, pl: 2, border: "1px solid grey" }}>
        <Stack direction="row" spacing={2} >
          <InputYear
            year={form.Year}
            birthYear={form.BirthYear}
            onChange={onChange_t}
            onError={(e) => myError("input_year", null, e)}
            tooltip="The specific year for this account."
          />
          <Stack spacing={2}>
            <Stack spacing={2} direction="row">
              <CollapseAddLabel
                label="Value"
                onClick={onAdd}
                tooltip="Add a new value entry."
              />
              <Stack spacing={2}>
                {Arrayify(form.Init).map((v, i) => (
                  <Stack key={"st-" + i} direction="row" spacing={5}>
                    <ValueInit
                      avail={avail}
                      form={v}
                      dosp={dosp}
                      doRepeat={doRepeat}
                      negative={negative}
                      onChange={(e) => onChangeMe("Init", e, i)}
                      onError={(e) => myError("valueInit", i, e)}
                      name={name}
                      doFinishMonth={accountType === "Employment" ? true : false}
                      birthYear={form.BirthYear}
                    />
                    {doReduceEoL && (
                      <ReduceEoL
                        form={v}
                        onChange_any={(n, v) => { myChangeInit(n, v, i) }}
                        errors={errors}
                        onError={(name, e) => myError(name, null, e)}
                      />
                    )}


                    <CollapseDeleteLabel
                      onClick={(e) => onDelete(e, v.Id)}
                      tooltip="Remove this value entry."
                    />
                  </Stack>
                ))}
              </Stack>

              {(doFrom &&
                <SourceAccounts
                  form={form.From}
                  avail={avail}
                  onChange={(v) => { onChange_any("From", v) }}
                  errors={errors}
                  onError={(e) => myError("From", null, e)}
                  width={100}
                  maxWidth
                  tooltip={"Select the tax treatment for this expense"}
                />
              )}
              <CollapseStateLabel
                add={addNotes}
                label="Notes"
                onClick={setAddNotes}
              />



              {accountType === "Employment" && (
                <>
                  {form.Employment !== undefined && form.Employment !== null && (
                    <Employment
                      form={form.Employment}
                      avail={avail}
                      onChange={(e) => onChange_any("Employment", e)}
                      onError={(e) => myError("Employment", null, e)}
                    />
                  )}
                  <Stack direction="row" spacing={2}>
                    <CollapseAddLabel
                      label="Match"
                      disabled={Arrayify(avail.MatchAccount).length === 0}
                      onClick={() => { onAddMatch(false) }}
                      tooltip={(Arrayify(avail.MatchAccount).length === 0 ? "Disabled as there are no available Match Accounts, " : "") + "Add a new matching"}
                    />
                    <CollapseAddLabel
                      label="Bonus"
                      onClick={() => { onAddMatch(true) }}
                      tooltip="Add a new bonus"
                    />
                    <Stack spacing={2}>
                      {Arrayify(form.Match).map((m, i) => (
                        <Stack key={"msd-" + m.Id} direction="row" spacing={2}>
                          <Match
                            avail={avail}
                            form={m}
                            onChange={(e) => onChangeMe("Match", e, i)}
                            onError={(e) => myError("Match", i, e)}
                            birthYear={form.birthYear}
                          />
                          <CollapseDeleteLabel
                            onClick={() => onDeleteMatch_i("Match", m.Id)}
                            tooltip="Remove match "
                          />
                        </Stack>
                      ))}
                    </Stack>
                  </Stack>
                </>
              )}
            </Stack>

            {addNotes && (
              <Stack direction="row" spacing={2} sx={{ mx: -4 }}>
                <Input_label
                  label="Notes"
                  name="Comment"
                  value={form.Comment}
                  maxLength={800}
                  width={800}
                  required={false}
                  onChange={onChange_t}
                  errors={errors}
                  onError={(name, e) => myError(name, null, e)}
                />

              </Stack>
            )}
          </Stack>


        </Stack>
      </Box >
    </Container >
  );
};

const AddSimpleAccount = ({
  show,
  close,
  client_p,
  clientJson,
  c_callback,
  account,
  account_uuid,
  accountType,
  add,
  dosp = false,
  doRepeat = false,
  negative = false,
  doReduceEoL = false,
  doTaxTreatment = false,
  doFrom = false,
}) => {
  const data = useRef();
  const [form, setForm] = useState();
  const [dataset, setDataset] = useState();
  const [client, setClient] = useState("");
  const [clients, setClients] = useState([]);
  const [added, setAdded] = useState([false, false]);
  const [errors, setErrors] = useState({})
  const [errmsg, setErrmsg] = useState("")
  const [deleted, setDeleted] = useState(false)

  const getInputData = (client_) => {
    let url = AccountUrl_get(clientJson, "account", account, account_uuid, add, accountType);
    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          setAdded([false, false]);
          data.current = json;
          setForm(json);
          setClients(json.Clients);
          Update(client_);
          // console.log(data.current);
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const putRequest = async () => {
    let url = AccountUrl_put(
      clientJson,
      "account",
      form.DataSet[client].Name,
      form.DataSet[client].AccountUuid,
      form.DataSet[client].NameOrig,
      add
    );
    var req = putOptions;
    let post = CleanAvail(form);
    req.body = JSON.stringify(post);
    ftchPlus(url, req)
      .then((json) => {
        console.log("update completed");

        myClose();
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const onSubmit = () => {
    console.log(form);
    putRequest();
  };

  const myClose = (e) => {
    data.current = null;
    setDataset(null);
    setClient("")
    setClients([])
    close(accountType);
  };

  useEffect(() => {
    if (show) {
      errorClear(errors)
      setErrmsg("")
      setDeleted(false)
      getInputData(client_p);
    }
  }, [show, client_p]);

  useEffect(() => {
    let cl = client === clients[0] ? 0 : 1;
    if (add && dataset && !added[cl]) {
      onAdd();
      let x = added;
      x[cl] = true;
      setAdded(x);
    }
  }, [add, dataset]);

  const Update = (cl) => {
    setClient(cl);
    setDataset(data.current.DataSet[cl]);
  };

  const myChange_any = (subpath, any) => {
    // console.log("any_change: ");
    // console.log(any);
    let path = "DataSet[" + client + "]";
    if (subpath !== "") {
      path += "." + subpath;
    }

    // console.log("Path: " + path);
    let nf = form;
    nf = set(nf, path, any);
    setForm(nf);
    nf = {
      ...nf,
    };
    setForm(nf);

    Update(client);
    validate(nf.DataSet[client])

    // console.log(nf);
  };

  const myChangeMe = (e, i) => {
    // console.log("SA");
    // console.log(e);
    // console.log(i);

    if (e.Init.length !== 0) {
      let path = "Annual[" + i + "]";
      myChange_any(path, e);
    } else {
      console.log(dataset);
      let path = "Annual[" + i + "]";
      myChange_any(path, e);
      let json = data.current.DataSet[client].Annual.slice();
      json = json.filter((o) => o.Init.length !== 0);
      console.log(json);
      myChange_any("Annual", json);
    }
  };

  const btnClientChanged = (cl) => {
    Update(cl);
  };


  const myChange_t = (e) => {
    myChange_any(e.target.name, e.target.value);
  };

  const validate = (f) => {
    console.log(f)
    let ne = structuredClone(errors)

    let err = ""
    if (doTaxTreatment && doFrom) {
      if (f.ExpenseType === "Donation (Stock)") {
        for (let j of Arrayify(f.Annual)) {
          let donation = 0
          let stockDonation = 0
          for (let i of Arrayify(j.Init)) {
            donation += Number(i.Value.Value)
          }

          for (let i of Arrayify(j.From)) {
            stockDonation += Number(i.Value.Value)
          }
          console.log(donation)
          console.log(stockDonation)

          if (donation !== stockDonation) {
            err = "From accounts and Values much match donation amount"
            break
          }
        }
      }
    }
    set(ne, "ExpenseType", err)
    setErrors(ne)
    console.log(ne)
    // if (onError !== null) {
    //   onError(errorJsonHasErrors(ne) ? "Errors" : "")
    // }
  }

  const onAdd = () => {
    if (dataset) {
      let n_ann = structuredClone(ann);
      let json = [];
      if (dataset.Annual) {
        json = dataset.Annual.slice();
        n_ann.Id = Math.max(...dataset.Annual.map((o) => o.Id), 0) + 1;
        n_ann.Year = Math.max(...dataset.Annual.map((o) => o.Year), 0) + 1;
      }
      if (n_ann.Year === 1) {
        n_ann.Year = new Date().getFullYear() - 1;
      }
      n_ann.BirthYear = dataset.BirthYear;
      json.push(n_ann);
      console.log(n_ann.Id)
      console.log(json);
      myChange_any("Annual", json);
    }
  };
  const onDelete = (e, Id) => {
    console.log(Id)
    let json = dataset.Annual.slice();
    json = json.filter((o) => o.Id !== Id);
    myChange_any("Annual", json);
    setDeleted(true)
  };

  const onError = (obj, i, err) => {
    if (i !== null) {
      obj += "[" + i + "]"
    }
    let e = set(errors, obj, err)
    // console.log(e)
    setErrors(e)
  }

  return (
    <>
      <AddDialog
        clientJson={clientJson}
        c_callback={c_callback}
        onClose={myClose}
        open={show}
        clients={clients}
        client={client}
        label={accountType}
        accountType={accountType}
        onClientChange={btnClientChanged}
        onSubmit={onSubmit}
        errors={errors}
        errmsg={errmsg}
        deleted={deleted}
      >
        {data !== null && dataset !== undefined && dataset !== null && (

          <Stack sx={{ mx: 4 }}>
            <Stack direction="row" spacing={2}>
              <InputName
                key="ds.name"
                value={dataset.Name}
                accountName={true}
                onChange={myChange_t}
                tooltip={"Name of the " + accountType + " account"}
                onError={(e) => onError("name", null, e)}
              />
              {dataset.Avail[accountType] !== undefined && dataset.Avail[accountType] !== null && (
                <Stack direction="row">
                  < InputButtonGroup
                    label="Account Type"
                    name="Type"
                    value={dataset.Type}
                    buttons={dataset.Avail[accountType]}
                    onChange={myChange_t}
                  />
                </Stack>

              )}
              {(doTaxTreatment &&
                <ExpenseType
                  label="Tax Treatment"
                  name="ExpenseType"
                  value={dataset.ExpenseType}
                  avail={dataset.Avail.ExpenseTypes}
                  onChange={myChange_t}
                  errors={errors}
                  onError={(name, e) => onError(name, null, e)}
                  width={100}
                  disabled={dataset.Type !== "Expenses"}
                  tooltip={"Select the tax treatment for this expense"}
                />
              )}
            </Stack>

            <Stack direction="row" spacing={2}>
              <Stack sx={{ py: 4 }}>
                <CollapseAdd
                  onClick={onAdd}
                  tooltip="Add a new year"
                />
              </Stack>


              <Stack spacing={-3}>
                {Arrayify(dataset.Annual).map((d, i) => (
                  <Stack key={i} direction="row" spacing={2}>
                    <ValueYear
                      accountType={accountType}
                      name={accountType}
                      avail={dataset.Avail}
                      form={d}
                      dosp={dosp}
                      doRepeat={doRepeat}
                      doReduceEoL={doReduceEoL}
                      doFrom={doFrom}
                      negative={negative}
                      doTaxTreatment={doTaxTreatment}
                      onChange={(e) => myChangeMe(e, i)}
                      onError={(e) => onError("value", i, e)}
                      expenseType={dataset.ExpenseType}
                    />
                    <Stack sx={{ py: 4 }}>
                      <CollapseDelete
                        onClick={(e) => onDelete(e, d.Id)}
                        tooltip="Remove this year for this account."
                      />
                    </Stack>
                  </Stack>
                ))}
              </Stack>
            </Stack>
          </Stack>

        )}

      </AddDialog>
    </>
  );
};

export default AddSimpleAccount;
